import { AanAfwezigheid } from 'src/app/afas-classes/aanafwezigheid.class';
import { Hourtype } from 'src/app/afas-classes/hourtype';
import { Realisation } from 'src/app/classes/realisation';
import { Settlement } from 'src/app/classes/settlement.class';
import { User } from 'src/app/classes/user.class';
import { Week } from '../../classes/week';
import { WeekDay } from '../../classes/weekday';

export enum TimeOnDay {
    Normal = 'Normal',
    Night = 'Night',
    Early = 'Early',
}

export type TimeTypeRealisationSettle = {
    realisation: Realisation;
    minutes: number;
    from: Date;
    to: Date;
    type: TimeOnDay;
};

export interface Settleable {
    set employee(value: Readonly<User>);
    get employee(): Readonly<User>;

    aanAfwezigheid: AanAfwezigheid[];
    fcHourTypeMap: Map<string, string>;
    hourTypes: Hourtype[];
    realisations: Realisation[];

    updateForm: (settlements: Settlement[], day: WeekDay) => void;

    /**
     * Proefverrekening: niets opslaan, formulieren ongemoeid laten en ook al verstuurde weken
     * doorrekenen.
     */
    dryRun: boolean;

    settleWeekHours(week: Week): Promise<void>;

    readonly OVERTIME_HOURTYPE_CODES: string[];

    constructor: Function;
}
